import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { globalStatus } from "../../../../utils/GlobalFunction";
import moment from "moment";

export default class SalesReportStore {
	AUTH = null
	agGrid = null;
	per_page = 5000;
	current_page = 1;
	list_data = null;
	total = 0;
	allColumnIds = [];
	
	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}


	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params
		const { api } = params		
		var defaultFromDate = moment().subtract(1, "month").format("YYYY-MM-DD");
		var defaultToDate = moment().format("YYYY-MM-DD");
		if (defaultFromDate && defaultToDate) {
			this.agGrid.api.setFilterModel({
				inv_date: { dateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"), dateTo: moment().subtract(1, "days").format("YYYY-MM-DD"), type: "inRange", filterType: "date" }
			});			
		}
		var datasource = this.createDatasource(ServerGridConfig.options)
		api.setServerSideDatasource(datasource)

	};

	// change page size, default page size is ServerGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel
		var final_sort = params.sortModel
		if (final_filter["acc_offer.status"]) {
			let values_changed = []
			final_filter["acc_offer.status"].values.forEach(x => (
				values_changed.push(globalStatus('accessory_offer_status_common_status', 'value', x))
			))
			final_filter["acc_offer.status"].values = values_changed
		}				
		if (final_filter["booking_ledger.insurance_offer.need_insurance"]) {
			let values_changed = []
			final_filter["booking_ledger.insurance_offer.need_insurance"].values.forEach(x => {
				values_changed.push(x === "No" ? 0 : 1)
			})
			final_filter["booking_ledger.insurance_offer.need_insurance"].values = values_changed
		}
		return { final_filter, final_sort }
	}



	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request)
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					// per_page: params.request.endRow - params.request.startRow,
					per_page: 5000,
					page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow))
				}
				this.getList(payload).then((data) => {
					if (data.data.total === 0) { this.agGrid.api.showNoRowsOverlay() }
					else { this.agGrid.api.hideOverlay() }
					params.successCallback(data.data.data, data.data.total)
					var allColumnIds = []
					if (this.agGrid && this.agGrid.columnApi && data.data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.colId)
						})
					}
				})
			}
		}
	}

	// call api to get records
	getList = (payload) => {
		return Axios.post(`/reports/booking_sales/sales_report`, payload).then(({ data }) => {
			if (data.data.data.length) {
				data.data.data.map((item, index) => {
					item.srno = index + 1;
					item.inv_date = item.inv_date ? moment(item.inv_date).format("DD/MM/YYYY") : "N/A";
					item.booking_model.promised_delivery_date = item.booking_model.promised_delivery_date ? moment(item.booking_model.promised_delivery_date).format("DD/MM/YYYY") : "N/A";
					item.booking_ledger.insurance_offer.need_insurance = item.booking_ledger.insurance_offer.need_insurance === 1 ? "Yes" : "No";
					return null;
				});
			}
			this.list_data =
				data.data.data.length ? data.data : null;
			this.total = data.total;
			this.current_page = data.current_page;
			return data
		});
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.rowModel.rowsToDisplay.length === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.rowModel.rowsToDisplay.length > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

}

decorate(SalesReportStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	type: observable,
	defaultType: observable,
	setListCustomDate:action,
	listCustomDate: observable,
});
